/* eslint-disable react/display-name */
import React, { useState } from 'react'
import { SettingOutlined } from '@ant-design/icons'
import { Space } from 'antd'
import { connect } from 'react-redux'
import { RootState } from 'Store'
import { selectRoleListEvent, selectRoleActionEvent } from 'Store/manage-role/selector'
import { selectCurrentUser } from 'Store/user/selector'
import { TableListPage } from 'Components/common/Table'
import { ActionButton } from 'Components/button'
import { selectRefreshPermissionEvent } from 'Store/manage-role-permission/selector'
import { selectPackagesSpec } from 'Store/pos/selector'
import { menuMerchantTypeSpecailConfig } from 'helpers/constanst'
import MerchantTypePermissions from './MerchantTypePermissions'

type Props = {} & ReduxProps

const MerchantTypes: React.FunctionComponent<Props> = props => {
  const [selectedName, setSelectedName] = useState('')
  const [showManagePermission, setShowManagePermission] = useState(false)

  const renderActionButton = (text: string, record: any) => (
    <Space size="middle">
      <ActionButton
        text=""
        icon={<SettingOutlined />}
        label="จัดการร้านค้าที่ใช้งาน"
        action="success"
        onClick={() => {
          setShowManagePermission(true)
          setSelectedName(record.value || 0)
        }}
      />
    </Space>
  )

  const columns = [
    {
      title: 'ลำดับ',
      dataIndex: 'no',
      key: 'no',
      render: (value: any, record: any, index: number) => {
        return index + 1
      },
      width: '60px',
    },
    {
      title: 'Merchant Type',
      dataIndex: 'name',
      key: 'name',
      //  render: renderCompanyInfo,
    },
    {
      title: '',
      key: 'action',
      render: renderActionButton,
      width: '100px',
    },
  ]

  const ManageDrawer = (
    <MerchantTypePermissions
      mode={''}
      merchant_type={selectedName}
      visible={showManagePermission}
      onCloseDrawer={() => setShowManagePermission(false)}
      onSuccess={() => {}}
    />
  )

  return (
    <>
      <TableListPage
        columns={columns}
        datas={menuMerchantTypeSpecailConfig}
        isLoading={false}
        paginationContent={null}
        scrollX={500}
        size="small"
      />
      {ManageDrawer}
    </>
  )
}

const mapStateToProps = (state: RootState) => {
  return {
    currentUser: selectCurrentUser(state),
    list: selectPackagesSpec(state),
    listEvent: selectRoleListEvent(state),
    event: selectRoleActionEvent(state),
    refreshPermissionEvent: selectRefreshPermissionEvent(state),
  }
}

type ReduxProps = ReturnType<typeof mapStateToProps>

export default connect(mapStateToProps)(MerchantTypes)
